// extracted by mini-css-extract-plugin
export default {"title":"YJ2pJ5xWrO","paragraph":"R7zcYW_epy","list":"PJ3nqWAYeW"};